$(function () {
    //Right to Left Open Menu
    if($('.navToggle').length > 0){
        $('.navToggle').on('click', function () {
            $('.sidebar-wrap').toggleClass('open-mobile-nav');            
            $('html').toggleClass('hidescroll');
        });
    };         
    
    //chat Message Click ot open Chat
    if($('.profile-button').length > 0){
        $('.profile-button').on('click', function () {
            $('.profile').toggleClass('open-profile-dropdown');           
        });
    }; 
});

$(function () {
    //Right to Left Open Menu
    if($('.toggleNav').length > 0){
        $('.toggleNav').on('click', function () {
            $('.fullNavbar-wrap').toggleClass('open-nav');            
            //$('html').toggleClass('hidescroll');
            $("body").toggleClass('sitenav-secondary-open');
        });
    };    
});

$(function () {
    //Right to Left Open Menu
    if($('.toggleSearch').length > 0){
        $('.toggleSearch').on('click', function () {
            $('.fullSearch-wrap').toggleClass('open-search');            
            //$('html').toggleClass('hidescroll');
            $("body").toggleClass('page-search-open');
        });
    };    
});

